<template>
<div v-if="visatype" class="container">

  <!-- SELECTED VISATYPE PANEL -->
  <div class="panel outer-panel">

    <!-- SECTION TABS -->
    <div class="panel-nav" style="margin-right:1em;">
      <ul class="tab">
        <li class="tab-item" :class="{active: secKey === -2}">
          <a href="#" @click.prevent="secKey = -2">Info</a>
        </li>
        <li class="tab-item" :class="{active: secKey === -1}">
          <a href="#" @click.prevent="secKey = -1">Documents</a>
        </li>
        <li v-for="(section, key) in visatype.sections" class="tab-item" :class="{active: secKey === key}">
          <a href="#" @click.prevent="showDocs = false;secKey = key">{{section.name}}</a>
        </li>
        <li class="tab-item tab-action">
          <div class="input-group input-inline">
            <input class="form-input input-sm" type="text" v-model="newSectionName" placeholder="New section"
                   v-on:keydown.enter="addSection">
            <button class="btn btn-primary btn-sm input-group-btn" @click="addSection">
              <i class="icon icon-plus"></i>
            </button>
          </div>
          <div class="input-group input-inline">
            <button class="btn btn-primary" :class="{loading: saving}" @click="saveType">Save</button>
          </div>
        </li>
      </ul>
    </div>
    <!-- END SECTION TABS -->

    <!-- INFO PANEL -->
    <div v-if="secKey === -2" class="panel-body">

      <div class="panel-body">

        <form class="form-horizontal">
          <div class="form-group">
            <div class="col-3">
              <label class="form-label">Matter Information</label>
            </div>
            <div class="col-9">
              <textarea v-model="visatype.info" class="form-input" placeholder="HTML" rows="10"></textarea>
            </div>
          </div>

          <div class="form-group">
            <div class="col-3">
              <label class="form-label">Checklist ID</label>
            </div>
            <div class="col-9">
              <input v-model="visatype.checklist_id" type="text" class="form-input">
            </div>
          </div>
        </form>
      </div>

    </div>
    <!-- END INFO PANEL -->

    <!-- DOCTYPES PANEL -->
    <div v-if="secKey === -1" class="panel-body">
      <div class="empty" v-if="!visatype.doctypes || !visatype.doctypes.length">
        <h5 class="empty-title">There are no documents for this matter type</h5>
        <div class="empty-action">
          <button class="btn btn-primary" @click="showDocModal = true">Make a document type</button>
        </div>
      </div>

      <table v-else class="table table-striped">
        <thead>
          <tr>
            <th>Description</th>
            <th>Help text</th>
            <th><button class="btn" @click="showDocModal = true">New</button></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(d, i) in visatype.doctypes">
            <td>{{d.name}}</td>
            <td>{{d.helptext}}</td>
            <td>
              <button class="btn btn-sm" @click="openEditDoc(d, i)">
                <i class="fa fa-pencil" aria-hidden="true"></i>
              </button>
              <button class="btn btn-sm" @click="delDoc(i)">
                <i class="fa fa-trash-o" aria-hidden="true"></i>
              </button>
              <button class="btn btn-sm" @click="moveDoc(i, 1)">
                <i class="icon icon-arrow-down"></i>
              </button>
              <button class="btn btn-sm" @click="moveDoc(i, -1)">
                <i class="icon icon-arrow-up"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- END DOCTYPES PANEL -->
      
    <!-- MATTER SECTIONS -->
    <div v-if="secKey >= 0" class="panel-body">

      <div class="empty" v-if="!visatype.sections.length">
        <h4 class="empty-title">There are no sections for this matter type</h4>
      </div>

      <div class="empty" v-else-if="!visatype.sections[secKey].subsections.length">
        <h4 class="empty-title">No subsections</h4>
      </div>

      <!-- SUBSECTION LOOP -->
      <div v-else v-for="(sub, subKey) in visatype.sections[secKey].subsections" class="panel subPanel">

        <div class="panel-header">
          <div class="panel-title" style="display:flex;align-items:center;">
            <p style="margin:0;">{{sub.name}}</p>
            <button class="btn btn-clear" @click="delSubsection(subKey)"></button>
          </div>
          <div class="subControls">
            <label class="form-checkbox" style="padding-right:0;">Repeatable
              <input type="checkbox" v-model="sub.repeatable" /><i class="form-icon"></i>
            </label> |
            <label class="form-checkbox" style="padding-right:0;">For Client
              <input type="checkbox" v-model="sub.for_client" /><i class="form-icon"></i>
            </label> |
            <a href="" @click.prevent="openDeps(sub, subKey)">Deps</a> |
            <button class="btn btn-sm" @click="moveSub(subKey, 1)">
              <i class="icon icon-arrow-down"></i>
            </button>
            <button class="btn btn-sm" @click="moveSub(subKey, -1)">
              <i class="icon icon-arrow-up"></i>
            </button>
          </div>
        </div>

        <div class="panel-body">
          <div v-if="!sub.questions.length" class="empty">
            <h4 class="empty-title">No questions</h4>
            <div class="empty-action">
              <button class="btn btn-primary" @click="openNewQ(subKey, 0)">Add a question</button>
            </div>
          </div>

          <table v-else class="table table-striped">
            <thead>
              <tr>
                <th style="width:30%">Question</th>
                <th style="width:40%">Help text</th>
                <th style="width:5%">Type</th>
                <!-- <th style="width:20%">IMMIFIELD</th> -->
                <th style="width:25%"></th>
              </tr>
            </thead>
            <tbody>
              <!--  QUESTION LOOP -->
              <tr v-for="(q, qKey) in sub.questions">
                <td style="width:30%">{{q.text}}</td>
                <td style="width:40%">{{q.helptext}}</td>
                <td style="width:5%">{{q.type}}</td>
                <!-- <td style="width:20%">{{q.immifield}}</td> -->
                <td style="text-align: right; width:25%">
                  <button class="btn btn-sm" @click="openEditQ(subKey, qKey)">
                    <i class="fa fa-pencil" aria-hidden="true"></i>
                  </button>
                  <button class="btn btn-sm" @click="delQ(subKey, qKey)">
                    <i class="fa fa-trash-o" aria-hidden="true"></i>
                  </button>
                  <button class="btn btn-sm" @click="openNewQ(subKey, qKey)">
                    <i class="icon icon-plus"></i>
                  </button>
                  <button class="btn btn-sm" @click="moveQ(subKey, qKey, 1)">
                    <i class="icon icon-arrow-down"></i>
                  </button>
                  <button class="btn btn-sm" @click="moveQ(subKey, qKey, -1)">
                    <i class="icon icon-arrow-up"></i>
                  </button>
                </td>
              </tr>
              <!--  END QUESTION LOOP -->
            </tbody>
          </table>

        </div>
      </div>
      <!-- END SUBSECTION LOOP -->
    </div>
    <!-- END MATTER SECTIONS -->

    <!-- SECTION FOOTER -->
    <div class="panel-footer" v-if="secKey >= 0">
      <div v-if="visatype.sections.length" class="columns">
        <div class="column col-8"></div>
        <div class="column col-2">
          <div class="input-group">
            <input class="form-input input-sm" v-model="newSubName" type="text" placeholder="New subsection"
                   v-on:keydown.enter="addSubsection">
            <button class="btn btn-primary input-group-btn btn-sm" @click="addSubsection">+</button>
          </div>
        </div>
        <div class="column col-2">
          <button class="btn btn-sm float-right" @click="delSection">Delete section</button>
        </div>
      </div>
    </div>
    <!-- END SECTION FOOTER -->

  </div>
  <!-- END SELECTED TYPE PANEL -->

  <!-- QUESTION MODAL -->
  <div class="modal" id="editQ" v-bind:class="{active: showQModal}">
    <div class="modal-overlay"></div>
    <div class="modal-container" style="width:64rem;">

      <div class="modal-header">
        <button class="btn btn-clear float-right" @click="closeQ"></button>
        <div class="modal-title">{{editingQ ? 'Edit question' : 'New question'}}</div>
      </div>
      <div class="modal-body">
        <div class="content">

          <form class="form-horizontal">
          <!-- <form> -->
            <div class="form-group">
              <div class="col-3">
                <label class="form-label" for="editqtype">Type</label>
              </div>
              <div class="col-9">
                <select class="form-select" id="editqtype" v-model="tempQ.type">
                  <option value="text">Text</option>
                  <option value="yn">Y/N</option>
                  <option value="select">Select</option>
                  <option value="date">Date</option>
                  <option value="number">Number</option>
                  <option value="textarea">Text area</option>
                  <option value="country">Country</option>
                  <option value="language">Language</option>
                </select>
              </div>
            </div>

            <div v-if="tempQ.type === 'select'" class="form-group">
              <div class="col-3">
                <label class="form-label" for="editqtxt">Options</label>
              </div>
              <div class="col-9">
                <textarea class="form-input" id="editqtxt" v-model="selectInput" placeholder="<display>, <value>">
                </textarea>
              </div>
            </div>

            <div class="form-group">
              <div class="col-3">
                <label class="form-label">Text</label>
              </div>
              <div class="col-9">
                <input class="form-input" type="text" id="editqtxt" v-model="tempQ.text" placeholder="Question text">
              </div>
            </div>

            <div class="form-group">
              <div class="col-3">
                <label class="form-label" for="editqhelptxt">Help text</label>
              </div>
              <div class="col-9">
                <input class="form-input" type="text" id="editqhelptxt" v-model="tempQ.helptext" placeholder="Help text">
              </div>
            </div>

            <!-- <div class="form-group">
              <div class="col-3">
                <label class="form-label" for="immifield_new">Immifield</label>
              </div>
              <div class="col-9">
                <input class="form-input" type="text" id="immifield_new" v-model="tempQ.immifield" placeholder="applicant_character_risk_people_smuggling_flag">
              </div>
            </div> -->

            <div class="form-group">
              <div class="col-3">
                <label class="form-label">Conditional</label>
              </div>
              <div class="col-9">
                <label class="form-checkbox">
                  <input class="form-input" type="checkbox" v-model="tempQ.dependent">
                  <i class="form-icon"></i>
                </label>
              </div>
            </div>

            <div class="form-group" v-if="tempQ.dependent">
              <div class="col-3">
                <label class="form-label">Display if</label>
              </div>
              <div class="col-9">
                <select v-model="tempQ.depends.ref" class="form-select">
                  <option value="">Choose a question</option>
                  <option v-for="q in boolQuestions" :value="q.ref">{{q.text}}</option>
                </select>
              </div>
            </div>

            <div class="form-group" v-if="tempQ.dependent">
              <div class="col-3">
                <label class="form-label">is</label>
              </div>
              <div class="col-9">
                <label class="form-radio">
                  <input type="radio" v-model="tempQ.depends.atxt" value="y" />
                  <i class="form-icon"></i>Yes
                </label>
                <label class="form-radio">
                  <input type="radio" v-model="tempQ.depends.atxt" value="n" />
                  <i class="form-icon"></i>No
                </label>
              </div>
            </div>

            <div class="form-group">
              <div class="col-3"></div>
              <div class="col-9">
                <button v-if="editingQ" class="btn btn-primary" @click="editQ">Done</button>
                <button v-else class="btn btn-primary" @click="addQ">Save</button>
                <!-- <button v-if="!editingQ" class="btn btn-link" @click="resetQ">Reset</button> -->
              </div>
            </div>

          </form>
        </div>

      </div>
      <div class="modal-footer">
        <!-- <button class="btn btn-link" @click="closeQ">Close</button> -->
      </div>
    </div>
  </div>
  <!-- END QUESTION MODAL -->

  <!-- DOC MODAL -->
  <div class="modal" v-bind:class="{active: showDocModal}">
    <div class="modal-overlay"></div>
    <div class="modal-container" style="width:64rem;">

      <div class="modal-header">
        <button class="btn btn-clear float-right" @click="closeQ"></button>
        <div class="modal-title">Edit document type</div>
      </div>
      <div class="modal-body">
        <div class="content">

          <form class="form-horizontal">

            <div class="form-group">
              <div class="col-3">
                <label class="form-label">Description</label>
              </div>
              <div class="col-9">
                <input class="form-input" type="text" v-model="tempDoc.name">
              </div>
            </div>

            <div class="form-group">
              <div class="col-3">
                <label class="form-label">Help text</label>
              </div>
              <div class="col-9">
                <textarea class="form-input" v-model="tempDoc.helptext"></textarea>
              </div>
            </div>

            <div class="form-group">
              <div class="col-3">
                <label class="form-label">Conditional?</label>
              </div>
              <div class="col-9">
                <label class="form-checkbox">
                  <input class="form-input" type="checkbox" v-model="tempDoc.dependent">
                  <i class="form-icon"></i>
                </label>
              </div>
            </div>

            <div class="form-group" v-if="tempDoc.dependent">
              <div class="col-3">
                <label class="form-label">Display if</label>
              </div>
              <div class="col-9">
                <select v-model="tempDoc.depends.ref" class="form-select">
                  <option value="">Choose a question</option>
                  <option v-for="q in boolQuestions" :value="q.ref">{{q.text}}</option>
                </select>
              </div>
            </div>

            <div class="form-group" v-if="tempDoc.dependent">
              <div class="col-3">
                <label class="form-label">is</label>
              </div>
              <div class="col-9">
                <label class="form-radio">
                  <input type="radio" v-model="tempDoc.depends.atxt" value="y" />
                  <i class="form-icon"></i>Yes
                </label>
                <label class="form-radio">
                  <input type="radio" v-model="tempDoc.depends.atxt" value="n" />
                  <i class="form-icon"></i>No
                </label>
              </div>
            </div>

            <div class="form-group">
              <div class="col-3"></div>
              <div class="col-9">
                <button v-if="editingDoc" class="btn btn-primary" @click="closeQ">Done</button>
                <button v-else class="btn btn-primary" @click="addDoc">Save</button>
              </div>
            </div>

          </form>
        </div>
      </div>
    </div>
  </div>
  <!-- END DOC MODAL -->

  <!-- DEPENDENCY MODAL -->
  <div v-if="visatype && subKey > -1" class="modal" id="editDeps" v-bind:class="{active: showDepsModal}">
    <div class="modal-overlay"></div>
    <div class="modal-container" style="width:64rem;">

      <div class="modal-header">
        <button class="btn btn-clear float-right" @click="showDepsModal = false"></button>
        <div class="modal-title">Dependencies</div>
      </div>
      <div class="modal-body">

        <div class="content">
          <form class="form-horizontal">

            <div class="form-group">
              <div class="col-3">
                <label class="form-label">Display if</label>
              </div>
              <div class="col-9">
                <select v-model="depRef" class="form-select">
                  <option value="">Choose a question</option>
                  <option v-for="q in boolQuestions" :value="q.ref">{{q.text}}</option>
                </select>
              </div>
            </div>

            <div class="form-group">
              <div class="col-3">
                <label class="form-label">is</label>
              </div>
              <div class="col-9">
                <label class="form-radio">
                  <input type="radio" v-model="depVal" value="y" />
                  <i class="form-icon"></i>Yes
                </label>
                <label class="form-radio">
                  <input type="radio" v-model="depVal" value="n" />
                  <i class="form-icon"></i>No
                </label>
              </div>
            </div>

            <div class="form-group">
              <div class="col-3"></div>
              <div class="col-9">
                <button class="btn btn-primary" @click.prevent="addDep">Save</button>
                <button class="btn btn-link" type="reset" @click="resetDep">Reset</button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-link" @click="showDepsModal = false">Close</button>
      </div>
    </div>
  </div>
  <!-- END DEPENDENCY MODAL -->

</div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'visatype',
  props: ['id'],
  data () {
    return {
      visatype: null,
      secKey: 0,
      subKey: -1,
      qKey: -1,
      newSectionName: '',
      newSubName: '',
      selectInput: '',
      showDocModal: false,
      showQModal: false,
      showDepsModal: false,
      editingQ: false,
      editingDoc: false,
      tempQ: null,
      tempDoc: null,
      depRef: null, // question selected as a dependency
      depVal: '', // value that selected question should be
      saving: false,
      error: false
    }
  },
  created () {
    this.$root.$data.pageTitle = ''
    this.resetQ()
    this.resetDoc()
    axios.get('/api/visatype/' + this.id)
    .then(res => {
      if (res.status === 200) {
        this.visatype = res.data
        this.$root.$data.pageTitle = res.data.name
      }
    })
    .catch(e => { console.log(e.response.data) })
  },
  computed: {
    allowNewSub () {
      return this.visatype.sections.length > 0
    },
    selectedQ: {
      get () {
        if (!this.visatype.sections[this.secKey] || this.subKey < 0 || this.qKey < 0) return null
        return this.visatype.sections[this.secKey].subsections[this.subKey].questions[this.qKey]
      },
      set (editedQ) {
        this.visatype.sections[this.secKey].subsections[this.subKey].questions.splice(this.qKey, 1, editedQ)
      }
    },
    // Find all the boolean questions in the current visatype
    boolQuestions () {
      var qs = []
      this.visatype.sections.forEach(sec => {
        sec.subsections.forEach(sub => {
          sub.questions.forEach(q => {
            if (q.type === 'yn') {
              qs.push(q)
            }
          })
        })
      })
      return qs
    }
  },
  methods: {
    addSection: function () {
      var name = this.newSectionName.trim()
      if (name === '') return
      this.visatype.sections.push({
        ref: Math.round(Math.random() * 100000),
        name: name,
        subsections: []
      })
      this.newSectionName = ''
    },
    addSubsection: function () {
      var name = this.newSubName.trim()
      if (name === '') {
        return
      }
      this.visatype.sections[this.secKey].subsections.push({
        ref: Math.round(Math.random() * 100000),
        name: name,
        repeatable: false,
        for_client: false,
        questions: []
      })
      this.newSubName = ''
    },
    delSection: function () {
      var delKey = this.secKey
      if (delKey > 0 && delKey === this.visatype.sections.length - 1) {
        this.secKey -= 1
      }
      this.visatype.sections.splice(delKey, 1)
    },
    delSubsection: function (key) {
      this.visatype.sections[this.secKey].subsections.splice(key, 1)
    },
    saveType: function () {
      this.saving = true
      axios.post('/api/update/visatypes/' + this.visatype._id, this.visatype)
      .then(res => {
        if (res.status === 200) {
          this.saving = false
        }
      })
      .catch(err => { console.log(err) })
    },
    delQ: function (subKey, qKey) {
      this.visatype.sections[this.secKey].subsections[subKey].questions.splice(qKey, 1)
    },
    delDoc: function (i) {
      this.visatype.doctypes.splice(i, 1)
    },
    editQ: function () {
      if (!this.validQ()) return
      this.closeQ()
    },
    addQ: function () {
      if (!this.validQ()) return
      // TODO: check for collisions
      this.tempQ.ref = Math.round(Math.random() * 100000) // Generate a reference number for the new question
      this.visatype.sections[this.secKey].subsections[this.subKey].questions.splice(this.qKey + 1, 0, this.tempQ)
      this.closeQ()
    },
    addDoc: function () {
      let d = this.tempDoc
      d.name = d.name.trim()
      d.helptext = d.helptext.trim()
      if (d.name === '') return
      // TODO: check for collisions
      d.ref = Math.round(Math.random() * 100000) // Generate a reference number for the new doctype
      if (!this.visatype.doctypes) {
        this.visatype.doctypes = [d]
      } else {
        this.visatype.doctypes.push(d)
      }
      this.closeQ()
    },
    validQ: function () {
      // Process the <select> values if given
      if (this.tempQ.type === 'select') {
        this.tempQ.selectVals = []
        var pairs = this.selectInput.split('\n')
        if (pairs.length < 2) return false
        var validPairs = pairs.every(pair => {
          var [k, v] = pair.split(',').map(s => { return s.trim() })
          if (k && v && k.length && v.length) {
            this.tempQ.selectVals.push([k, v])
            return true
          }
          return false
        })
        if (!validPairs) {
          console.log('invalid pairs')
          return false
        }
        this.selectInput = ''
      }
      return this.tempQ.type !== '' && this.tempQ.text.trim().length > 0
    },
    openNewQ: function (subKey, qKey) {
      this.showQModal = true
      this.subKey = subKey
      this.qKey = qKey
    },
    openEditQ: function (subKey, qKey) {
      this.editingQ = true
      this.subKey = subKey
      this.qKey = qKey
      this.tempQ = this.selectedQ // copied by reference!
      this.showQModal = true

      // Setup the selectInput textarea if the type is <select>
      if (this.tempQ.type === 'select') {
        this.selectInput = this.tempQ.selectVals.map(([k, v]) => {
          return k + ', ' + v
        }).join('\n')
      }
    },
    openEditDoc: function (doc, index) {
      this.editingDoc = true
      this.tempDoc = doc
      this.showDocModal = true
    },
    // Close both question and doc modals
    closeQ: function () {
      this.showQModal = false
      this.showDocModal = false
      this.editingQ = false
      this.editingDoc = false
      this.resetQ()
      this.resetDoc()
    },
    resetQ: function () {
      this.tempQ = {
        type: 'text',
        text: '',
        helptext: '',
        // immifield: '',
        selectVals: [],
        dependent: false,
        depends: {
          ref: '',
          atxt: ''
        }
      }
      this.selectInput = ''
    },
    resetDoc: function () {
      this.tempDoc = {
        name: '',
        helptext: '',
        dependent: false,
        depends: {
          ref: '',
          atxt: ''
        }
      }
    },
    openDeps: function (sub, subKey) {
      this.subKey = subKey
      this.showDepsModal = true
      this.depRef = ''
      this.depVal = ''
      if (sub.depends && sub.depends.ref) {
        this.depRef = sub.depends.ref
      }
      if (sub.depends && sub.depends.ans) {
        this.depVal = sub.depends.atxt
      }
    },
    addDep: function () {
      if (!this.depRef && !this.depVal) {
        delete this.visatype.sections[this.secKey].subsections[this.subKey].depends
      } else if (!this.depRef || !this.depVal) {
        return
      } else {
        this.visatype.sections[this.secKey].subsections[this.subKey].depends = {
          ref: this.depRef,
          atxt: this.depVal
        }
      }
      this.showDepsModal = false
      this.depRef = ''
      this.depVal = ''
    },
    resetDep: function () {
      this.depRef = ''
      this.depVal = ''
    },
    // Move an element in an array
    movePosition: function (arr, key, dir) {
      if (dir === -1 && key === 0) return
      if (dir === 1 && key >= arr.length - 1) return
      var s = arr[key]
      var temp = arr[key + dir]
      if (dir === -1) {
        arr.splice(key - 1, 2, s, temp)
      } else {
        arr.splice(key, 2, temp, s)
      }
    },
    moveSub: function (subKey, dir) {
      var subs = this.visatype.sections[this.secKey].subsections
      this.movePosition(subs, subKey, dir)
    },
    moveQ: function (subKey, qKey, dir) {
      var questions = this.visatype.sections[this.secKey].subsections[subKey].questions
      this.movePosition(questions, qKey, dir)
    },
    moveDoc: function (i, dir) {
      this.movePosition(this.visatype.doctypes, i, dir)
    }
  }
}
</script>

<style scoped>
.outer-panel {
  border: none;
}
.sectionBtns button {
  margin-right: 5px;
}
.subPanel {
  margin-top: 10px;
}
.subPanel .panel-header {
  display: flex;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// visatype.vue?80a47c20